import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useUi } from "@/i18n/ui";
import { resetPassword, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const { lang, applyAuth } = useApp();
  const t = useUi(lang);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError(t("passwordsNoMatch"));
      return;
    }
    setBusy(true);
    try {
      const data = await resetPassword(token, password);
      setDone(true);
      if (data.access_token) {
        applyAuth(data.access_token, data.user);
        const staff = data.user?.role === "admin" || data.user?.role === "trainer" || data.user?.role === "hr";
        setTimeout(() => navigate(staff ? "/admin/users" : "/app"), 1200);
      } else {
        setTimeout(() => navigate("/login"), 1500);
      }
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rbl-auth-wrap" data-testid="reset-page">
      <div className="rbl-auth-card">
        <img src="/logo_rbl.png" alt="RBL Training" style={{ height: 48 }} />
        <h1>{t("resetTitle")}</h1>
        {done ? (
          <div className="rbl-ok" data-testid="reset-success">{t("passwordSaved")}</div>
        ) : (
          <>
            {error && <div className="rbl-error" data-testid="reset-error">{error}</div>}
            <form onSubmit={submit}>
              <div className="rbl-field">
                <label className="rbl-label">{t("newPassword")}</label>
                <input className="rbl-input" type="password" data-testid="reset-password"
                  value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
              </div>
              <div className="rbl-field">
                <label className="rbl-label">{t("confirmPassword")}</label>
                <input className="rbl-input" type="password" data-testid="reset-confirm"
                  value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} />
              </div>
              <button className="rbl-btn block" type="submit" disabled={busy || !token} data-testid="reset-submit">
                {busy ? "…" : t("savePassword")}
              </button>
            </form>
          </>
        )}
        <div className="rbl-auth-foot">
          <Link to="/login" className="rbl-link">{t("login")}</Link>
          <Link to="/" className="rbl-link">{t("backToHub")}</Link>
        </div>
      </div>
    </div>
  );
}
